module.exports = __webpack_public_path__ + "media/images/partner-info-50645e45660e6b7373d79233555f9d10.png";